import React, { useEffect, useState } from "react";

import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { delete_icon, View_icon } from "../../assets/img";
import Select from "react-select";
import { URLS } from "../../Services/Constant";
import { deletes, get, post } from "../../Services/ApiHandler";
import { Toast } from "../../Component/Toast";
import Loader from '../../Component/Loader'
import DateRange0 from "../../Component/DateRange/DateRange0";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";

const HolidayUpdate = () => {


  const { kv, set } = useStoreKv();
  const holidayList = kv.holidaylist || [];


  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState("");

  const [popup, setPopup] = useState(false);
  const [Announce, setAnnounce] = useState(false);
  const [time, setTime] = useState(null);
  const [time2, setTime2] = useState(null);
  const [timeOptions, setTimeOptions] = useState([]);
  const [timeOptionsDear, setTimeOptionsDear] = useState([]);
  const [reasonDear, setReasonDear] = useState('');
  const [reasonKerala, setReasonKerala] = useState('');
  const [reasonOver, setReasonOver] = useState('');

  const [slotData, setSlotData] = useState();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [fromDateDear, setFromDateDear] = useState(null);
  const [toDateDear, setToDateDear] = useState(null);
  const [fromDateOver, setFromDateOver] = useState(null);
  const [toDateOver, setToDateOver] = useState(null);
  const [showReason, setShowReason] = useState('');
  const [holidayId, setHolidayId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [popup1, setPopup1] = useState(false);
  const [updateType, setUpdateType] = useState(null);
  const [popupLoader, setPopupLoader] = useState(false);

  const [owners, setOwners] = useState(holidayList);


  const getList = async () => {
    try {
      // setLoading(true);
      const resList = await get(`${URLS.GETALLHOLIDAY}`);
//       console.log("Fetched list data:", resList);
      if (resList?.status === "success" && resList?.data) {
        setOwners(resList?.data);
        set("holidaylist", resList?.data);
      } else {
        setOwners([]);
        set("holidaylist", []);
      }

      const res = await get(`${URLS.GETGMAELIST}`);
//       console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        const list = res.data
          .filter(item => item?.lot_time && item.name === 'Kerala')
          .map(item => ({
            value: item.lot_time,
            label: item.lot_time,
          }));

        setTimeOptions(list);

        const listDear = res.data
          .filter(item => item?.lot_time && item.name !== 'Kerala')
          .map(item => ({
            value: item.lot_time,
            label: item.lot_time,
          }));

        setTimeOptionsDear(listDear);
        setSlotData(res?.data);
      }
      // setLoading(false);
    } catch (err) {
      Toast("Failed to load links");
      console.error(err);
      // setLoading(false);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
//     console.log("holidayId updated:", holidayId);
  }, [holidayId]);


  const columns = React.useMemo(
    () => [
      {
        Header: "From Date",
        accessor: "from_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "To   Date",
        accessor: "to_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Lot Name",
        accessor: "lot_name",
        Cell: ({ value, row }) => {
          return <p>{value === 'Kerala' ? "Kerala" : "Dear"}</p>;
        },
      },
      {
        Header: "Lot Time",
        accessor: "lot_time",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Reason",
        accessor: "reason",
        Cell: ({ value, row }) => {
          return (
            <p
              style={{
                whiteSpace: "nowrap" /* Keep text in a single line */,
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "130px",
              }}
            >
              {value}
            </p>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                <button onClick={() => {
                  setAnnounce(true);
                  setShowReason(row?.original?.reason);
                }} className="cust-btn ">
                  <img src={View_icon} alt="" className="view-btn" />
                </button>

                <button onClick={() => {
                  setPopup(true);
                  setHolidayId(row?.original?.id);
//                   console.log("row?.original?.id", row?.original?.id);

                }} className="cust-btn ">
                  <img src={delete_icon} alt="" className="delete-icon" />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 8,
      border: "1px solid #00474366",
      border: `1px solid ${state.isFocused || state.hasValue ? "#004743" : "#00474366"}`,
      boxShadow: state.isFocused
        ? "transparent"
        : "0 0 0 1px #dffffd66",
      "&:hover": {
        border: "1px solid #00474366",
      },
      backgroundColor: "#F0EDE6",
      minHeight: 51,
      padding: "3px 10px",
      fontFamily: state.isSelected ? "f3" : "f2",
      color: "#000",
    }),

    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "transparent"
        : state.isFocused
          ? "transparent"
          : "transparent",
      color: state.isSelected
        ? "#00211fff"
        : "#004743",
      cursor: "pointer",
      ":active": {
        backgroundColor: "#00474333",
      },
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#004743",
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#004743",
      "&:hover": {
        color: "#004743",
      },
    }),
  };


  const convertToAPIDate = (dateStr) => {
    if (!dateStr) return "";
    const [d, m, y] = dateStr.split("-");
    return `${y}-${m}-${d}`;
  };


  const handleUpdate = async (slot) => {

    if (slot === 'kerala') {
      if (!fromDate || !toDate || !reasonKerala.trim()) {
        Toast("Please fill all required fields for Kerala Holiday.");
        return;
      }
      // if (fromDate > toDate) {
      //   Toast("From Date cannot be later than To Date for Kerala Holiday.");
      //   return;
      // }
    } else {
      if (!fromDateDear || !toDateDear || !reasonDear.trim()) {
        Toast("Please fill all required fields for Dear Holiday.");
        return;
      }
      // if (fromDateDear > toDateDear) {
      //   Toast("From Date cannot be later than To Date for Dear Holiday.");
      //   return;
      // }
    }


    if (!Array.isArray(slotData)) {
//       console.log("slotData is not an array");
      return;
    }
    const Kerala = slotData.find((item) => item?.code === '1');

    const Dear = slotData.filter((item) => item?.code === '2') || [];

//     console.log("Kerala =", Kerala);
//     console.log("Dear =", Dear);
//     console.log("time2", time2?.value);

    const dearId = Dear.find((i) => i?.lot_time === time2?.value);
//     console.log("dearId", dearId);

    const postData = {
      game_id: slot === 'kerala' ? Kerala?.id : dearId?.id,
      from_date: slot === 'kerala' ? convertToAPIDate(fromDate) : convertToAPIDate(fromDateDear),
      to_date: slot === 'kerala' ? convertToAPIDate(toDate) : convertToAPIDate(toDateDear),
      type: 2,
      reason: slot === 'kerala' ? reasonKerala : reasonDear
    }

    if (slot === 'kerala') {
      setLoading2(true);
    } else {
      setLoading3(true);
    }

//     console.log("postData", postData);
    const res = await post(URLS.HOLIDAYUPDATE, postData);
//     console.log("res holiday update", res);

    if (res.status === "success") {
      if (slot === 'kerala') {
        setFromDate(null);
        setToDate(null);
        setReasonKerala('');
        setTime(null);
      } else {
        setFromDateDear(null);
        setToDateDear(null);
        setReasonDear('');
        setTime2(null);
      }
      getList();
      if (slot === 'kerala') {
        setLoading2(false);
      } else {
        setLoading3(false);
      }
      Toast(res.message || "Updated Successfully!");
    } else {
      if (slot === 'kerala') {
        setLoading2(false);
      } else {
        setLoading3(false);
      }
    }

  }


  const handleOverAllUpdate = async () => {

    // Validation for Overall Holiday
    if (!fromDateOver || !toDateOver || !reasonOver.trim()) {
      Toast("Please fill all required fields for Overall Holiday.");
      return;
    }
    // if (fromDateOver > toDateOver) {
    //   Toast("From Date cannot be later than To Date for Overall Holiday.");
    //   return;
    // }

    const postData = {
      from_date: convertToAPIDate(fromDateOver),
      to_date: convertToAPIDate(toDateOver),
      reason: reasonOver
    }
    setLoading4(true);
    const res = await post(URLS.HOLAIDYOVERALL, postData);
//     console.log("res holiday update", res);
    if (res.status === "success") {
      setFromDateOver(null);
      setToDateOver(null);
      setReasonOver('');
      setLoading4(false);
      getList();
      Toast(res.message || "Updated Successfully!");
    } else {
      setLoading4(false);
    }
  }



  const handleDelete = async () => {
    if (!holidayId) return;
    setLoading1(true)
    const res = await deletes(`${URLS.GETALLHOLIDAY}/${holidayId}/delete`);
//     console.log("res delete", res);
    if (res.status === "success") {
      setPopup(false);
      getList();
      setLoading1(false);
    } else {
      setLoading1(false);
    }
  }



  return (
    <div className="dashRightView d-flex ac-jb flex-column">
      <CustomScroll height="100vh">
        <div className="container_overalls">
          <div className="d-flex ac-js col-md-5 my-3">
            <label className="form-label f3 fs-xs-20 fs-sm-14 fs-md-15 fs-lg-18 fs-xl-19 fs-xxl-22  primary">
              Kerala Lot
            </label>
          </div>
          <div>
            <DateRange0
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
            />
          </div>
          <div className="col-lg-5 my-3 pb-2">
            <div className="d-flex ac-js">
              <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
                Time
              </label>
            </div>
            <Select
              className="location-search"
              onChange={setTime}
              options={timeOptions}
              value={time}
              placeholder="Select Time"
              styles={customStyles}
              isSearchable={false}
              noOptionsMessage={() => ""}
            />
          </div>
          <div className="col-md-5 my-3 announcement_box">
            <h4 className="f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announcement_title">
              Reason
            </h4>
            <textarea
              className="form-control5 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-19 placholdercolorchanges2"
              placeholder="Type here..."
              onChange={(e) => setReasonKerala(e.target.value)}
              value={reasonKerala}
              rows="4"
            ></textarea>
          </div>
          <div className="col-md-5 my-3">
            <button onClick={() => { setPopup1(true); setUpdateType('kerala'); }} className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white">
              {loading2 ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : 'Update'}
            </button>
          </div>
          <div className="d-flex ac-js col-md-5 my-3">
            <label className="form-label f3 fs-xs-20 fs-sm-14 fs-md-15 fs-lg-18 fs-xl-19 fs-xxl-22  primary">
              Dear Lot
            </label>
          </div>
          <div>
            <DateRange0
              fromDate={fromDateDear}
              toDate={toDateDear}
              setFromDate={setFromDateDear}
              setToDate={setToDateDear}
            />
          </div>
          <div className="col-lg-5 my-3 pb-2">
            <div className="d-flex ac-js">
              <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
                Time
              </label>
            </div>
            <Select
              className="location-search"
              onChange={setTime2}
              options={timeOptionsDear}
              value={time2}
              placeholder="Select Time"
              styles={customStyles}
              isSearchable={false}
              noOptionsMessage={() => ""}
            />
          </div>
          <div className="col-md-5 my-3 announcement_box">
            <h4 className="f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announcement_title">
              Reason
            </h4>
            <textarea
              className="form-control5 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-19 placholdercolorchanges2"
              placeholder="Type here..."
              onChange={(e) => setReasonDear(e.target.value)}
              value={reasonDear}
              rows="4"
            ></textarea>
          </div>
          <div className="col-md-5 my-3">
            <button onClick={() => { setPopup1(true); setUpdateType('dear'); }} className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white">
              {loading3 ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : 'Update'}
            </button>
          </div>
          <div className="d-flex ac-js col-md-5 my-3">
            <label className="form-label f3 fs-xs-20 fs-sm-14 fs-md-15 fs-lg-18 fs-xl-19 fs-xxl-22  primary">
              Overall Holiday
            </label>
          </div>
          <div>
            <DateRange0
              fromDate={fromDateOver}
              toDate={toDateOver}
              setFromDate={setFromDateOver}
              setToDate={setToDateOver}
            />
          </div>

          <div className="col-md-5 my-3 announcement_box">
            <h4 className="f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announcement_title">
              Reason
            </h4>
            <textarea
              className="form-control5 f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-19 placholdercolorchanges2"
              placeholder="Type here..."
              onChange={(e) => setReasonOver(e.target.value)}
              value={reasonOver}
              rows="4"
            ></textarea>
          </div>
          <div className="col-md-5 my-3">
            <button onClick={() => { setPopup1(true); setUpdateType('overall'); }} className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white">
              Update
            </button>
          </div>

          <div className="d-flex ac-js col-md-5 my-3">
            <label className="form-label f3 fs-xs-20 fs-sm-14 fs-md-15 fs-lg-18 fs-xl-19 fs-xxl-22  primary">
              Holiday List
            </label>
          </div>

          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={owners}
            show={false}
          />
        </div>

        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure you want to Delete?
              </p>
              <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2  f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button onClick={() => setPopup(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={handleDelete}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading1 ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    <span style={{ top: -1.5, position: 'relative' }}>Yes</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
        {Announce && (
          <div onClick={() => setAnnounce(false)} className="img-popup-design3">
            <div className="img-popup3">
              <button className="close-btn" onClick={() => setAnnounce(false)}>
                ×
              </button>
              <h4 className="f4 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announement_title2">
                Message
              </h4>

              <textarea
                className="placholdercolorchanges2"
                name="reason"
                placeholder="Type your reason here..."
                value={showReason}
                rows="4"
              />
            </div>
          </div>
        )}
        {loading && <Loader />}
        {popup1 && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure you want to Update?
              </p>
              <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2  f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button onClick={() => setPopup1(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={async () => {
                    setPopupLoader(true);
                    if (updateType === 'kerala' || updateType === 'dear') {
                      await handleUpdate(updateType);
                    } else if (updateType === 'overall') {
                      await handleOverAllUpdate();
                    }
                    setPopup1(false);
                    setUpdateType(null);
                    setPopupLoader(false);
                  }}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {popupLoader ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    <span style={{ top: -1.5, position: 'relative' }}>Yes</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>
    </div>
  );
};

export default HolidayUpdate;
